module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "topic-mapping"
    }
  }, [_c('v-breadcrumbs', {
    attrs: {
      "items": [{
          text: 'Kodifikasi',
          to: {
            path: '/'
          }
        },
        {
          text: 'Mapping'
        } ],
      "divider": "|"
    }
  }), _vm._v(" "), _c('h3', {
    staticClass: "header-text font-weight-bold"
  }, [_vm._v("Mapping")]), _vm._v(" "), _vm._l((_vm.groups), function(group) {
    return _c('v-card', {
      key: group.name,
      staticClass: "my-4 pa-4"
    }, [_c('v-card-title', {
      staticClass: "pa-0 pb-3 font-weight-bold text-subtitle-1"
    }, [_vm._v("\n            " + _vm._s(group.name) + "\n        ")]), _vm._v(" "), _c('v-card-text', {
      staticClass: "pa-0 ma-0"
    }, [_c('v-container', {
      staticClass: "pa-0",
      attrs: {
        "fluid": ""
      }
    }, [_c('v-row', _vm._l((group.grades), function(grade, gradeIndex) {
      return _c('v-col', {
        key: gradeIndex,
        staticClass: "pa-3",
        attrs: {
          "cols": "4"
        }
      }, [_c('v-card', {
        staticClass: "test_cursor",
        attrs: {
          "flat": "",
          "outlined": "",
          "to": _vm.getNavigation(grade)
        },
        on: {
          "click": function($event) {
            return _vm.mappingDetail(grade)
          }
        }
      }, [_c('v-card-text', [_c('v-list', {
        staticClass: "pa-0 ma-0",
        attrs: {
          "width": "100%"
        }
      }, [_c('v-list-item', {
        staticClass: "pa-0 ma-0"
      }, [_c('v-list-item-content', {
        staticClass: "pa-0 ma-0"
      }, [_c('v-list-item-title', {
        staticClass: "text-subtitle-1 font-weight-bold black--text",
        staticStyle: {
          "word-break": "break-word !important"
        }
      }, [_vm._v("\n                                                " + _vm._s(grade.display_name) + "\n                                            ")]), _vm._v(" "), _c('v-list-item-subtitle', {
        staticClass: "text-body",
        staticStyle: {
          "word-break": "break-word !important"
        }
      }, [_vm._v("\n                                                " + _vm._s(grade.jenjang.nama) + "\n                                            ")])], 1), _vm._v(" "), _c('v-list-item-action', {
        staticClass: "pa-0 ma-0"
      }, [_c('v-icon', [_vm._v("mdi-chevron-right")])], 1)], 1)], 1)], 1)], 1)], 1)
    }), 1)], 1)], 1)], 1)
  }), _vm._v(" "), _c('v-dialog', {
    attrs: {
      "transition": "dialog-top-transition",
      "width": "536px",
      "height": "168px",
      "scrollable": ""
    },
    on: {
      "click:outside": function($event) {
        _vm.showModal = false
      }
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(dialog) {
        return [_c('v-card', [_c('v-card-title', {
          staticClass: "pa-0",
          attrs: {
            "width": "100%"
          }
        }, [_c('v-list-item', {
          staticStyle: {
            "min-height": "auto"
          },
          attrs: {
            "two-line": ""
          }
        }, [_c('v-list-item-content', [_c('v-list-item-title', {
          staticClass: "font-weight-bold"
        }, [_vm._v("\n                                Peminatan\n                            ")])], 1), _vm._v(" "), _c('v-list-item-action', [_c('v-btn', {
          attrs: {
            "plain": "",
            "icon": "",
            "small": ""
          },
          on: {
            "click": function($event) {
              dialog.value = false
            }
          }
        }, [_c('v-icon', [_vm._v("mdi-close-circle")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('v-card-text', {
          staticClass: "pa-2",
          attrs: {
            "width": "100%"
          }
        }, [_c('v-container', {
          attrs: {
            "fluid": ""
          }
        }, [_c('v-row', [_c('v-row', _vm._l((_vm.modalOptions), function(option, index) {
          return _c('v-col', {
            key: index,
            staticClass: "py-4 px-2",
            attrs: {
              "cols": "6"
            }
          }, [_c('v-card', {
            staticClass: "test_cursor",
            attrs: {
              "flat": "",
              "outlined": "",
              "to": {
                path: '/topic-mapping/detail',
                query: {
                  interest: option.interest,
                  grade_id: _vm.selectedGrade.id,
                },
              }
            }
          }, [_c('v-card-text', {
            staticClass: "py-2"
          }, [_c('v-list', {
            staticClass: "pa-0 ma-0",
            attrs: {
              "width": "100%"
            }
          }, [_c('v-list-item', {
            staticClass: "pa-0 ma-0"
          }, [_c('v-list-item-avatar', [_c('v-img', {
            attrs: {
              "width": "48px",
              "src": option.icon
            }
          })], 1), _vm._v(" "), _c('v-list-item-content', {
            staticClass: "pa-0 ma-0"
          }, [_c('v-list-item-title', {
            staticClass: "text-subtitle-1 font-weight-bold black--text",
            staticStyle: {
              "word-break": "break-word !important"
            }
          }, [_vm._v("\n                                                            " + _vm._s(option.label) + "\n                                                        ")])], 1), _vm._v(" "), _c('v-list-item-action', {
            staticClass: "pa-0 ma-0"
          }, [_c('v-icon', [_vm._v("mdi-chevron-right")])], 1)], 1)], 1)], 1)], 1)], 1)
        }), 1)], 1)], 1)], 1)], 1)]
      }
    }]),
    model: {
      value: (_vm.showModal),
      callback: function($$v) {
        _vm.showModal = $$v
      },
      expression: "showModal"
    }
  }), _vm._v(" "), (_vm.isLoading) ? _c('app-spinner') : _vm._e()], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-7b9daa73","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/modules/kodifikasi/components/TopicMapping.vue
// module id = 1565
// module chunks = 1